import { useContext } from 'react';
import CapabilityContext from 'context/CapabilityContext';

const EMPTY_SET = new Set();

/**
 * Read the logged-in user's role capabilities.
 *
 * Called with a capability code it answers for that one capability; called
 * with no argument it exposes the whole context, for components that need
 * several checks or the assignable role list.
 *
 * @param {String} [capability] capability code, e.g. 'hosts.manage'
 * @returns {object} capability helpers, plus `allowed` when a code is given
 */

const useCan = (capability) => {
  const context = useContext(CapabilityContext);

  // Guards against use outside the provider, so a gate degrades to closed
  // rather than throwing and taking the page down with it.
  if (!context) {
    return {
      allowed: false,
      can: () => false,
      canAny: () => false,
      capabilities: EMPTY_SET,
      assignableRoles: [],
      loading: false,
      isResolved: true,
      isStoreUser: false,
      refreshCapabilities: () => Promise.resolve(),
    };
  }

  if (!capability) {
    return context;
  }

  return {
    ...context,
    allowed: context.can(capability),
  };
};

export default useCan;
